// src/routes/HomeOrDashboard.jsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Home from "../pages/Home";

export default function HomeOrDashboard() {
  const { user } = useContext(AuthContext);

  // Si hay sesión, NO renderiza Home, redirige de una
  if (user) return <Navigate to="/dashboard" replace />;

  return <Home />;
}